import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './styles/App.css';
import App from './App';

Sentry.init({
  dsn: "https://eab12e86ac7b824f3ac90fd8905bf707@o4509555159924736.ingest.de.sentry.io/4509555160907856",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, // Captura el 100% de las transacciones
  tracePropagationTargets: ["localhost", "https://barbermujica.com"], // URLs donde se propagará el tracing
  // Session Replay
  replaysSessionSampleRate: 0.1, // Muestra el 10% de las sesiones
  replaysOnErrorSampleRate: 1.0, // 100% de sesiones donde ocurre un error

});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
